import {SET_USER_INFO} from "../actions/user";

const initialState = {}

export default (state = initialState, action) => {
    const {payload, type} = action;
    switch (type) {
        case SET_USER_INFO: {
            return {...state, userData: payload};
        }
        default:
            return state;
    }
}